// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./main.app.js", import.meta.url);
// Module
var code = "<!DOCTYPE html> <html> <head> <meta charset=\"utf-8\"> <title>Webpack Output</title> <meta name=\"viewport\" content=\"width=device-width,initial-scale=1\"><" + "script defer=\"defer\" src=\"" + ___HTML_LOADER_IMPORT_0___ + "\"><" + "/script></head> <body> </body> </html>";
// Exports
export default code;